
import axios from 'axios';

// app config
import AppConfig from 'Constants/AppConfig';
import AuthHeader from 'Constants/AuthHeader';
import {
    OCTWEDGE_ACTION,
    ALL_OCTWEDGE,
    ADD_OCTWEDGE,
    FETCH_OCTWEDGE,
    EDIT_OCTWEDGE,
    DELETE_OCTWEDGE,
    FETCH_OCTWEDGECHART,
    FETCH_WEDGESHOTCHART,
} from 'Actions/types';

import { NotificationManager } from 'react-notifications';
/**
 * On Course Wedge Play Actions
 */

    export const allOCTWedgePlay = () =>{    
    
        return (dispatch) => { 
            dispatch({ type: OCTWEDGE_ACTION });
            return axios.get(AppConfig.apiurl+'/api/getcoursehudyds', { headers: AuthHeader.header })         
            .then(response => {             
                const alldata=response.data.data;
                dispatch({ type: ALL_OCTWEDGE, payload: alldata });
            });
        }        
    
    }

    export const studentOCTWedgePlay = (id, start, end) =>{
    
        var payload={
            "id":id,
            "startdate":start,
            "enddate":end
        }

        return (dispatch) => { 
            dispatch({ type:OCTWEDGE_ACTION, });
            return axios.post(AppConfig.apiurl+'/api/studentcoursehudyds', payload,{ headers: AuthHeader.header })         
            .then(response => { 
                const alldata=response.data.data;
                dispatch({ type: ALL_OCTWEDGE, payload: alldata }); 
            });
        
        }
    }

    export const addOCTWedgePlay = (data, sepmore) =>{
        var id=data.target.student.value;
        var payload={
            "totval":1,
            "student_1":data.target.student.value,
            "sgdate":data.target.seldate.value,
            "shtot_1":sepmore,
        }

        for (let i = 0; i<sepmore; i++) {  
            
            var distance='distance_'+i;            
            var distanceval=data.target[distance].value;        
            var right='right_'+i;            
            var rightval=data.target[right].value;
            var left='left_'+i;            
            var leftval=data.target[left].value;
            var short='short_'+i;            
            var shortval=data.target[short].value;
            var long='long_'+i;            
            var longval=data.target[long].value;
            var area='area_'+i;            
            var areaval=data.target[area].value;
            var contact='contact_'+i;            
            var contactval=data.target[contact].value;
            var sepopt='putt_'+i;            
            var seoptval=data.target[sepopt].value;
            var septravel='missedgreen_'+i;            
            var setrvalval=data.target[septravel].value;           
            
            var adval=i+1;
            var distadd='distance_1_'+adval;
            var rightadd='right_1_'+adval;  
            var leftadd='left_1_'+adval;  
            var shortadd='short_1_'+adval;  
            var longadd='long_1_'+adval;  
            var areaadd='area_1_'+adval;
            var contadd='contact_1_'+adval;
            var sepoptadd='putt_1_'+adval; 
            var septraveladd='dhg_1_'+adval;  

            payload[distadd]=distanceval;
            payload[rightadd]=rightval;
            payload[leftadd]=leftval;
            payload[shortadd]=shortval;
            payload[longadd]=longval;
            payload[areaadd]=areaval;
            payload[contadd]=contactval;
            payload[sepoptadd]=seoptval;
            payload[septraveladd]=setrvalval;            
    
        }

        return (dispatch) => { 
            dispatch({ type:OCTWEDGE_ACTION, });
            return axios.post(AppConfig.apiurl+'/api/addcoursehudyds', payload,{ headers: AuthHeader.header })         
            .then(response => {             
                var resdata=response.data;
                if(resdata.status===1){
                    studentOCTWedgePlay(id, '', '')(dispatch);
                    fetchOnWedgeChart(id, '', '', '', '', '')(dispatch);
                    NotificationManager.success(resdata.message);               
                    dispatch({ type: ADD_OCTWEDGE});                    
                }
                return Promise.resolve(resdata);
                
            });
        
        }
    }

    export const editOCTWedgePlay = (data, sepmore, olddat) =>{
        var id=data.target.student.value;
        var payload={
            "totval":1,
            "student":data.target.student.value,
            "sgdate":data.target.seldate.value,
            "shtot_1":sepmore,
            "olddate":olddat
        }

        for (let i = 0; i<sepmore; i++) {  
            
            var distance='distance_'+i;            
            var distanceval=data.target[distance].value;        
            var right='right_'+i;            
            var rightval=data.target[right].value;
            var left='left_'+i;            
            var leftval=data.target[left].value;
            var short='short_'+i;            
            var shortval=data.target[short].value;
            var long='long_'+i;            
            var longval=data.target[long].value;
            var area='area_'+i;            
            var areaval=data.target[area].value;
            var contact='contact_'+i;            
            var contactval=data.target[contact].value;
            var sepopt='putt_'+i;            
            var seoptval=data.target[sepopt].value;
            var septravel='missedgreen_'+i;            
            var setrvalval=data.target[septravel].value;           
            
            var adval=i+1;
            var distadd='distance_1_'+adval;
            var rightadd='right_1_'+adval;  
            var leftadd='left_1_'+adval;  
            var shortadd='short_1_'+adval;  
            var longadd='long_1_'+adval;  
            var areaadd='area_1_'+adval;
            var contadd='contact_1_'+adval;
            var sepoptadd='putt_1_'+adval; 
            var septraveladd='dhg_1_'+adval;  

            payload[distadd]=distanceval;
            payload[rightadd]=rightval;
            payload[leftadd]=leftval;
            payload[shortadd]=shortval;
            payload[longadd]=longval;
            payload[areaadd]=areaval;
            payload[contadd]=contactval;
            payload[sepoptadd]=seoptval;
            payload[septraveladd]=setrvalval;            
    
        }

        return (dispatch) => { 
            dispatch({ type:OCTWEDGE_ACTION, });
            return axios.post(AppConfig.apiurl+'/api/editcoursehudyds', payload,{ headers: AuthHeader.header })         
            .then(response => {             
                var resdata=response.data;
                if(resdata.status===1){
                    studentOCTWedgePlay(id, '', '')(dispatch);
                    fetchOnWedgeChart(id, '', '', '', '', '')(dispatch);
                    NotificationManager.success(resdata.message);               
                    dispatch({ type: EDIT_OCTWEDGE});                    
                }
                return Promise.resolve(resdata);
                
            });
        
        }
    }

    export const fetchOCTWedgePlay = (id, date) =>{
    
        var payload={
            "id":id,
            "date":date
        }
        return (dispatch) => { 
            dispatch({ type:OCTWEDGE_ACTION, });
            return axios.post(AppConfig.apiurl+'/api/getchydetails', payload,{ headers: AuthHeader.header })         
            .then(response => {             
                var resdata=response.data;
                if(resdata.status===1){              
                    dispatch({ type: FETCH_OCTWEDGE, payload: resdata.data});                    
                }
                return Promise.resolve(resdata);
                
            });
        
        }
    }


    export const deleteOCTWedgePlay = (id, date) =>{
    
        var payload={
            "id":id,
            "date":date
        }        
        return (dispatch) => { 
            dispatch({ type:OCTWEDGE_ACTION, });
            return axios.post(AppConfig.apiurl+'/api/deletecoursehudyds', payload,{ headers: AuthHeader.header })         
            .then(response => {             
                var resdata=response.data;
                if(resdata.status===1){
                    studentOCTWedgePlay(id, '', '')(dispatch);
                    fetchOnWedgeChart(id, '', '', '', '', '')(dispatch);
                    NotificationManager.success(resdata.message);               
                    dispatch({ type: DELETE_OCTWEDGE});                    
                }                
                
            });
        
        }
    }

    export const fetchOnWedgeChart = (id, start, end, distance, area, contact) =>{
    
        var payload={
            "id":id,
            "startdate":start,
            "enddate":end,
            "contact":contact,
            "distance":distance,
            "area":area                
        }

        return (dispatch) => { 
            dispatch({ type:OCTWEDGE_ACTION, });
            return axios.post(AppConfig.apiurl+'/api/onwedgeplayreport', payload,{ headers: AuthHeader.header })         
            .then(response => {             
                var resdata=response.data.data;
                var wedge=resdata.wedge;
                dispatch({ type: FETCH_OCTWEDGECHART, payload: wedge}); 
                
                return Promise.resolve(resdata);
                
            });
        
        }
    }

    export const fetchOnWedgeShotChart = (id, start, end, distance, area, contact, val) =>{
    
        var payload={
            "id":id,
            "startdate":start,
            "enddate":end,
            "contact":contact,
            "distance":distance,
            "area":area,
            "section":val            
        }
    
        return (dispatch) => { 
            dispatch({ type:OCTWEDGE_ACTION, });
            return axios.post(AppConfig.apiurl+'/api/onwedgeshotchart', payload,{ headers: AuthHeader.header })         
            .then(response => {             
                var resdata=response.data.data;
                dispatch({ type: FETCH_WEDGESHOTCHART, payload: resdata}); 
                
                return Promise.resolve(resdata);
                
            });
        
        }
    }

    